<template>
  <div class="progress-bar" :class="cssType">
    <div class="progress-bar-border"></div>
    <div class="progress-bar-inner" :style="calcInnerWidth()"></div>
    <div class="progress-bar-items">
      <div
        class="progress-bar-item"
        v-for="(item, index) in props.list" :key="item.id"
        :style="calcStyle(index)"
        :class="{ active: checkIsActive(item.lotteryTimes, index), 'not-reach': props.lotteryTimes < item.lotteryTimes }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  lotteryTimes: {
    type: Number,
    default: 0,
  },
  list: {
    type: Array,
    default: () => [],
  },
})

const getIndex = () => {
  let currIndex = -1
  const lastLotteryTimes = props.list[props.list.length - 1]?.lotteryTimes || Infinity
  if (props.lotteryTimes >= lastLotteryTimes) {
    return props.list.length - 1
  }
  props.list.reduce((preLotteryTimes, curr, index) => {
    if (props.lotteryTimes >= preLotteryTimes && props.lotteryTimes < curr.lotteryTimes) {
      currIndex = index - 1
    }
    return curr.lotteryTimes
  }, 0)
  return currIndex
}
const checkIsActive = (lotteryTimes, index) => {
  const nextLotteryTimes = props.list[index + 1]?.lotteryTimes || Infinity
  if (props.lotteryTimes >= lotteryTimes && props.lotteryTimes < nextLotteryTimes) {
    return true
  }
  return false
}
const calcStyle = (index) => {
  if (isMobile) {
    return {
      top: `${(index * 100 / (props.list.length - 1))}%`
    }
  }
  return {
    left: `${(index * 100 / (props.list.length - 1))}%`,
  }
}
const calcInnerWidth = () => {
  let res = ''
  const currIndex = getIndex()
  if (currIndex === -1) {
    res = 0 + '%'
  } else {
    res = (currIndex / (props.list.length - 1)) * 100 + '%'
  }
  if (isMobile) {
    return {
      height: res,
    }
  } else {
    return {
      width: res
    }
  }
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>